import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const startingPrice = Math.min(...product.variants.map((v) => v.price));

  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className={`group block neon-border rounded-lg overflow-hidden card-hover fade-in-up fade-in-up-delay-${(index % 4) + 1}`}
      style={{ background: 'var(--bg-surface)' }}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden" style={{ background: 'var(--bg-primary)' }}>
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300 group-hover:scale-105 transition-transform"
        />
        <div
          className="absolute top-3 left-3 text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded"
          style={{
            background: 'rgba(0,240,255,0.1)',
            border: '1px solid rgba(0,240,255,0.2)',
            color: 'var(--neon-cyan)',
            fontFamily: "'Roboto Mono', monospace",
          }}
        >
          {product.category}
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3
          className="text-xl font-bold mb-2 group-hover:text-[var(--neon-cyan)] transition-colors duration-300"
          style={{ fontFamily: "'Rajdhani', sans-serif" }}
        >
          {product.name}
        </h3>
        <p className="text-xs leading-relaxed mb-4 line-clamp-2" style={{ color: 'var(--text-secondary)' }}>
          {product.short_description}
        </p>

        {/* Variants preview */}
        <div className="flex items-center gap-2 mb-4 flex-wrap">
          {product.variants.map((v) => (
            <span
              key={v.mg}
              className="text-sm px-2.5 py-0.5 rounded font-medium"
              style={{
                border: '1px solid rgba(229,0,255,0.2)',
                color: 'var(--neon-magenta)',
                fontFamily: "'Roboto Mono', monospace",
              }}
            >
              {v.mg}
            </span>
          ))}
        </div>

        {/* Price + CTA */}
        <div className="flex items-center justify-between">
          <div>
            <span className="text-[10px] uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>
              From
            </span>
            <span className="ml-2 text-lg font-bold neon-text-cyan" style={{ fontFamily: "'Rajdhani', sans-serif" }}>
              ${startingPrice}
            </span>
          </div>
          <ArrowRight
            className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
            style={{ color: 'var(--neon-cyan)' }}
          />
        </div>
      </div>
    </Link>
  );
}
